// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-0d7670f0] {\n  padding-left: 1.5rem;\n}\n.sub-item[data-v-0d7670f0] {\n  width: 100%;\n  margin-right: 12px;\n}\n.text-blue-600[data-v-0d7670f0] {\n  color: #1c64f2 !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
